/**
 * Button-Baustein für Blogbeiträge.
 *
 * Schreibweise im Text (echtes Markdown, deshalb ohne Renderer lesbar):
 *
 *   ```button
 *   Jetzt Beratung anfragen | /kontakt
 *   ```
 *
 * Links die Beschriftung, rechts das Ziel. Erlaubt sind interne Pfade
 * (beginnend mit „/") sowie vollständige http(s)-Adressen. Andere Schemata
 * (etwa `javascript:`) gelten als ungültig und werden nicht dargestellt.
 */

export const BUTTON_BLOCK_LANG = "button";

/** Vorlage der Werkzeugleiste; die Schreibmarke steht auf der Beschriftung. */
export const BUTTON_BLOCK_SNIPPET =
  "```button\nJetzt Beratung anfragen | /kontakt\n```";

/** Zeichenversatz vom Blockbeginn bis zum Anfang der Beschriftung. */
export const BUTTON_BLOCK_LABEL_OFFSET = "```button\n".length;

export type ButtonBlock = { label: string; href: string; external: boolean };

export function parseButtonBlock(raw: string | null | undefined): ButtonBlock | null {
  if (!raw) return null;
  const line = raw
    .split(/\r?\n/)
    .map((l) => l.trim())
    .find((l) => l.length > 0);
  if (!line) return null;
  const sep = line.lastIndexOf("|");
  if (sep === -1) return null;
  const label = line.slice(0, sep).trim();
  const href = line.slice(sep + 1).trim();
  if (!label || !href) return null;

  if (/^https?:\/\//i.test(href)) return { label, href, external: true };
  if (href.startsWith("/") && !href.startsWith("//")) {
    return { label, href, external: false };
  }
  return null;
}
